/* @flow */

import { responseHasError } from '../diplomatico/reducers/helper';
import type { Action } from '../diplomatico/types';
import mergeWithReplace from '../helpers/mergeWithReplace';
import { enableInitializing } from 'initializable-reducer';

const initialState = {};

function schoolGeneralAchievementCardsProgress(state: Object = initialState, { type, payload }: Action) {
  switch (type) {
    case 'RESPONSE_SCHOOL_GENERAL_ACHIEVEMENT_CARDS_PROGRESS':
      if (responseHasError(payload)) {
        return state;
      }

      const { intelligence_id } = payload._meta.payload.request;

      const newAchievementCardScore = {
        [intelligence_id]: payload.body
      };

      return mergeWithReplace({}, [state, newAchievementCardScore]);
    default:
      return state;
  }
}

export {
  schoolGeneralAchievementCardsProgress,
  initialState
};

export default enableInitializing(schoolGeneralAchievementCardsProgress);
